<p-toast key="maintoast" [breakpoints]="{ '376px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<!-- <app-spinner></app-spinner> -->
<app-layout>
  <router-outlet></router-outlet>
</app-layout>
<p-scrollTop [buttonProps]="{ rounded: true, severity: 'contrast' }" [threshold]="100" icon="pi pi-arrow-up" styleClass="right-0 ml-2"></p-scrollTop>
@if (showLoader) {
  <p-blockUI appPageLoadingOverlay [blocked]="true" styleClass="app-loading-overlay">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </p-blockUI>
}
<router-outlet name="standalone"></router-outlet>
